import Vue from 'vue';
import Cadpa from './index.vue';

let instance = null;
const CadpaBox = Vue.extend(Cadpa);
Cadpa.install = (options) => {
    if (!instance) {
        instance = new CadpaBox({
            data: options,
        }).$mount();
        document.body.appendChild(instance.$el);
    }
    return instance.init(options);
};
export default Cadpa;
